import { createUseStyles } from "react-jss";
import { foregroundColor, alpha } from "../../theme/Mixins";

export default createUseStyles({
    paginatedTable: {
        composes: "paginated-table",
    },
    table: {
        background: ({ theme }) => alpha("#fff", theme.ControlAlpha),
        color: ({ theme }) => theme.ForegroundColorDark,
        borderCollapse: "collapse",
        borderRadius: ({ theme }) => Math.min(theme.BorderRadius, 20),
        overflow: "hidden",
        boxShadow: ({ theme }) =>
            theme.BorderWidth > 1 && `0 0 0 ${theme.BorderWidth}px ${theme.ControlBorderColor}`,
        margin: ({ theme }) => theme.BorderWidth > 1 && theme.BorderWidth,

        "& td, & th": {
            padding: [[8, 24]],
            border: 0,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 400,
        },
    },
    tableRow: {
        composes: "row",
        transition: "background 100ms, color 100ms",
    },
    tableRowAlternate: {
        background: ({ theme }) => alpha(theme.ControlBackground, theme.ControlAlpha),
    },
    tableRowSelectable: {
        composes: "row--selectable",
        cursor: "pointer",
        userSelect: "none",
    },
    tableRowSelected: {
        composes: "row--selected",
        background: ({ theme }) => theme.ControlAlpha !== 0 && theme.PrimaryColor,
        color: ({ theme }) =>
            theme.ControlAlpha !== 0 && foregroundColor(theme, theme.PrimaryColor),
    },
    tableRowCheckbox: {
        padding: "6px !important",

        "& span": {
            height: 32,
        },
    },
    tableColumn: {
        background: ({ theme }) => theme.SecondaryColor,
        color: ({ theme }) => foregroundColor(theme, theme.SecondaryColor),
        textAlign: "left",
        fontWeight: "normal",
        cursor: "pointer",
        userSelect: "none",
    },
    tableColumnFilter: {
        background: ({ theme }) => theme.SecondaryColor,
        color: ({ theme }) => foregroundColor(theme, theme.SecondaryColor),
        padding: "0 6px 8px 6px !important",
    },
    tableColumnFilterInput: {
        display: "block",
        boxSizing: "border-box",
        width: "100%",
        background: "#fff",
        padding: "8px 18px",
        fontSize: "14px",
        outline: 0,
        border: 0,
    },
    sortedColumn: {
        fontWeight: "bolder",
    },
});
